import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RequestedUpdateFields } from '../../model/candidate-application.model'
import { ILanguage } from '../../model/language.model'
import { UserMode } from '../../model/component-modes.enum'

@Component({
  selector: 'candidate-language',
  template: `<!-- Request Information -->
    <e11-empty-state
      *ngIf="!languages || (languages.length === 0 && userMode !== userModeEnum.Candidate)"
      [icon]="'language'"
      [iconSize]="'md-36'"
      containerClassOverrides="e11-mt-0"
      title="{{ 'No Languages' | translate }}"
      [subtitle]="
        openRequest ? 'Requested on ' + (requestTimestamp | date : 'MM/dd/yyyy - hh:mm a') : ('Candidate did not supply any languages.' | translate)
      "
      [clickable]="false"
      [borderColor]="openRequest ? 'e11-border-skin-secondary' : ''"
      [showButton]="true"
      [buttonValue]="openRequest ? 'Pending Request' : 'Request Languages'"
      [buttonColor]="
        openRequest
          ? 'e11-border-skin-secondary e11-text-skin-secondary'
          : 'e11-border-skin-primary-accent hover:e11-bg-skin-primary-accent/20 e11-text-skin-primary-accent'
      "
      [buttonIcon]="openRequest ? 'pending' : ''"
      (buttonClicked)="!requestsDisabled && requestModal()"
      [disabled]="!!openRequest"
    >
    </e11-empty-state> `,
  styleUrls: [],
})
export class CandidateLanguageComponent {
  @Input() languages: ILanguage[] = []
  @Input() openRequest?: RequestedUpdateFields
  @Input() requestsDisabled = false
  @Input() userMode = UserMode.Candidate
  @Input() requestTimestamp?: string

  @Output() requestFromComponent = new EventEmitter()

  userModeEnum = UserMode

  requestModal() {
    this.requestFromComponent.emit('Language')
  }
}
